import ReliabalityReport from '@/views/ReliabalityReport/index'
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: "/",
    name: "ReliabalityReport",
    component: ReliabalityReport,
    meta: {
     // requireAuth: true,
      title: "ReliabalityReport List - Microchip"
         },
  },
  {
    path: "/:cpn([^=&?]+)",
    name: "ReliabalityReportByCpn",
    component: ReliabalityReport,
    meta: {
      title: "ReliabalityReport List - Microchip"
    
  }
}
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
